import classNames from 'classnames'
import React from 'react'
import SeoFaqBlock from 'src/components/carriersPage/seoFaqBlock'
import useI18n from 'src/hooks/use_i18n'
import { AllCarriersInfoDTO, CarrierInfoMarkDTO } from 'src/types'
import { filterRegex } from 'src/utils/carriers_info'
import { arrKeyContacts } from 'src/utils/tools'
import HowDoITrack from './howDoITrack'
import Styles from './index.module.scss'
import WhatDifferent from './whatDifferent'
import WhatCanWeDo from './whatcanwedo'
import WhoIsUse from './whoIsUse'
import WhyIntegrate from './whyIntegrate'

interface Props {
  carriersInfoData?: any
  carrier: AllCarriersInfoDTO
  totalCarriersStr: number | string
  carrierInfoMark: CarrierInfoMarkDTO
  carriersDataType: string
  carrierName: string
  country?: string
}

export default function CarriersInfoNormal({
  carriersInfoData,
  carrier,
  totalCarriersStr,
  carrierInfoMark,
  carriersDataType,
  carrierName,
  country
}: Props) {
  const { activeLocale: locale } = useI18n()
  return (
    <>
      <section
        className={classNames(Styles['details-faq'], 'fixWidth')}
        itemScope
        itemType="https://schema.org/FAQPage"
      >
        {/* 哈希导航 */}
        {carriersDataType === 'seo' && JSON.stringify(carriersInfoData) !== '{}' && (
          <div className={classNames(Styles['faq-nav'])}>
            {arrKeyContacts(carriersInfoData, ['qaList', 'qaList2']).map((qaItem: any, listIndex) => {
              return (
                <React.Fragment key={`faq-nav-${listIndex}`}>
                  {qaItem.question && (
                    <a key={`question-${listIndex}`} href={`#${filterRegex(qaItem.question, /[ ?]/g, '-')}`}>
                      {qaItem.question}
                    </a>
                  )}

                  {qaItem.answer.map((answerItem, answerIndex) => {
                    return answerItem.headerText ? (
                      <a
                        key={`headerText-${answerIndex}`}
                        href={`#${filterRegex(answerItem.headerText, /[ ?]/g, '-')}`}
                      >
                        {answerItem.headerText}
                      </a>
                    ) : null
                  })}
                </React.Fragment>
              )
            })}
          </div>
        )}

        {carriersDataType === 'seo' && JSON.stringify(carriersInfoData) !== '{}' && (
          <>
            <SeoFaqBlock
              carriersFaqBlockData={carriersInfoData.qaList}
              carrierName={carrierName}
              totalCarriersStr={totalCarriersStr}
            ></SeoFaqBlock>

            <SeoFaqBlock
              carriersFaqBlockData={carriersInfoData.table}
              carrierName={carrierName}
              totalCarriersStr={totalCarriersStr}
              blockType="table"
            ></SeoFaqBlock>

            <SeoFaqBlock
              carriersFaqBlockData={carriersInfoData.qaList2}
              carrierName={carrierName}
              totalCarriersStr={totalCarriersStr}
            ></SeoFaqBlock>

            <WhatDifferent
              carriersInfoData={carriersInfoData}
              totalCarriersStr={totalCarriersStr}
              configAnswer={true}
              carrierName={carrierName}
            />
            <WhyIntegrate carriersInfoData={carriersInfoData} carrierName={carrierName} />
            <WhoIsUse
              carrierInfoMark={carrierInfoMark}
              totalCarriersStr={totalCarriersStr}
              carriersInfoData={carriersInfoData}
              carrierName={carrierName}
            />

            <SeoFaqBlock
              carriersFaqBlockData={carriersInfoData.footerSeoText}
              carrierName={carrierName}
              totalCarriersStr={totalCarriersStr}
            ></SeoFaqBlock>
          </>
        )}

        {carriersDataType === 'normal' && JSON.stringify(carriersInfoData) !== '{}' && (
          <>
            {/* how Do I 通用模板第一段 */}
            <HowDoITrack carrier={carrier} totalCarriersStr={totalCarriersStr} carrierName={carrierName} />
            {/* what is different 通用模板第二段 */}
            <WhatDifferent totalCarriersStr={totalCarriersStr} carrierName={carrierName} />
            {/* how can i 通用模板第三段 */}
            {locale == 'en' && (
              <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                <h2 id={filterRegex('integrate' + carrierName, /[ ?]/g, '-')} itemProp="name">
                  How Can I Contact {carrierName} Customer Service?
                </h2>

                <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                  <div itemProp="text">
                    <h4>You can contact {carrierName} customer service in several ways:</h4>
                    <ul>
                      {carrier._tel && (
                        <li>
                          <strong>Phone: </strong>
                          {carrier._tel}
                        </li>
                      )}
                      {carrier._email && (
                        <li>
                          <strong>Phone: </strong>
                          {carrier._email}
                        </li>
                      )}

                      <li>
                        <strong>Website: </strong>Visit their contact page for more information and live chat options.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {/* why integrate 通用模板第四段 */}
            <WhyIntegrate carrierName={carrierName} />
            {/* who is using 通用模板第五段 */}
            <WhoIsUse carrierInfoMark={carrierInfoMark} totalCarriersStr={totalCarriersStr} carrierName={carrierName} />

            <SeoFaqBlock
              carriersFaqBlockData={carriersInfoData.section9}
              carrierName={carrierName}
              totalCarriersStr={totalCarriersStr}
            ></SeoFaqBlock>
          </>
        )}

        {(!['seo', 'normal'].includes(carriersDataType) || JSON.stringify(carriersInfoData) === '{}') && (
          <>
            {/* how Do I 通用模板第一段 */}
            <HowDoITrack carrier={carrier} totalCarriersStr={totalCarriersStr} carrierName={carrierName} />
            {/* what is different 通用模板第二段 */}
            <WhatDifferent totalCarriersStr={totalCarriersStr} carrierName={carrierName} />
            {/* how can i 通用模板第三段 */}
            {locale == 'en' && (
              <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                <h2 id={filterRegex('integrate' + carrierName, /[ ?]/g, '-')} itemProp="name">
                  How Can I Contact {carrierName} Customer Service?
                </h2>

                <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                  <div itemProp="text">
                    <h4>You can contact {carrierName} customer service in several ways:</h4>
                    <ul>
                      {carrier._tel && (
                        <li>
                          <strong>Phone: </strong>
                          {carrier._tel}
                        </li>
                      )}
                      {carrier._email && (
                        <li>
                          <strong>Phone: </strong>
                          {carrier._email}
                        </li>
                      )}

                      <li>
                        <strong>Website: </strong>Visit their contact page for more information and live chat options.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {/* why integrate 通用模板第四段 */}
            <WhyIntegrate carrierName={carrierName} />
            {/* who is using 通用模板第五段 */}
            <WhoIsUse carrierInfoMark={carrierInfoMark} totalCarriersStr={totalCarriersStr} carrierName={carrierName} />
          </>
        )}
      </section>
      {/* 广告位 国内不展示广告位2024-11-27*/}
      {country === 'CN' ? null : (
        <section className={classNames('ad-slot', Styles['gad-container'])} id="V6-Carriers-Bottom"></section>
      )}
      <WhatCanWeDo carrierName={carrierName}></WhatCanWeDo>
    </>
  )
}
